import { createSlice } from "@reduxjs/toolkit";
import { WritableDraft } from "immer/dist/internal";
import { setProp } from "Store/Actions";
import { setPropT } from "Store/Actions/ts";
import setObj from "lodash/set";
import { preCiqInformation } from "Pages/pre-ciq-network/Constants/preCiqInformation";
import { access } from "fs";
const initialData = {
    taskList: [],
    tabList: [],
    tabSelected: "",
    showCommentsSectionProps: {
        showCommentsSection: false,
        showCommentsWrapperDiv: true,
        commentsOverlayPanelWidth: 0
    },
    taskEdit: false,
    addUserModel: false,
    asideBlockHeight: 0,
    activeIcon: "",
    taskLoading: false,
    selectedProcess: {},
    selectedProcessConfig: {},
    taskContentLoading: false,
    selectedTaskData:{},
    addUserDetails: {addUserLoading: false, message: "", addbutton: false},
    updateData: false,
    networkComments: {
    comments: [],
    loading: false,
    error: null
  },
  commentData: {
    isEdit: false,
    selectedComment: {}
  },
  taskSearchList: [],
  searchTextEmpty: Date.now(),
  searchValue: "",
  taskUploadFileList: [],
  task_file_types: {accept: [],count: 1},
  taskUploading: false,
  snackbarMessage: "",
  taskTotalCount: 0,
  taskManageDialog: false,
  // taskManageDetails: {type: "",start_date: "", end_date: "", comment: "",reason: ""}
  taskManageDetails: {},
  taskPrevStartData: ""
}
const taskSlice = createSlice({
    name: 'task',
    initialState: initialData,
    reducers:{
        setTasksList(state, action){
            state.taskList = action.payload;
        },
    setNetworkComments(state, action) {
      state.networkComments['comments'] = action.payload;
    },
    setNetworkCommentsProps(state, action) {
      const { key, value } = action.payload
      state.networkComments = {
        ...state.networkComments,
        [key]: value,
      };
    },
    setCommentData(state, action) {
      const { isEdit, selectedComment } = action.payload;
      state.commentData.isEdit = isEdit;
      state.commentData.selectedComment = selectedComment;
    },
    },
      extraReducers(builder) {
            builder.addCase(setProp, (state, action: setPropT) => {
                if (action.payload.slice === taskSlice.name) {
                    setObj(state, action.payload.key, action.payload.value);
                }
            })
        }
  
})
export default taskSlice.reducer;
export const {setTasksList,setNetworkComments,setNetworkCommentsProps,setCommentData} = taskSlice.actions;